<tt-page class="col-xs-12 col-md-6 sp-0" *ngIf="!!itemsListCheckListDatas">
    <tt-card>
        <tt-button-goto [ttText]="'checklist_new'" (ttClick)="goToFunc('selectchecklistadd')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListCheckListDatas"></tt-list>
</tt-page>
